export default __webpack_public_path__ + "static/media/webgpu-later.f2a99884.svg";